import React from 'react';
import { INTERNAL_SIGN_IN_URL, openInternalSignIn } from '../../services/internalApi';

/**
 * Shown when the internal API ping fails. The usual cause is a missing
 * Cloudflare Access session for the internal host in this browser (the app
 * calls it cross-origin); the other is the VPN being off.
 */
export default function InternalApiUnreachable({ title, onRetry }) {
  return (
    <div className="card-surface p-6">
      <div className="flex items-start gap-3 border-l-4 border-red-500 bg-red-50 p-4 text-red-900">
        <i className="material-icons-outlined shrink-0">cloud_off</i>
        <div>
          <p className="font-medium">{title || 'Could not reach the internal API'}</p>
          <p className="mt-1 text-sm opacity-90">
            You may need to sign in to the internal API (Cloudflare Access) in this browser, or the VPN is off.
            Sign in in the tab that opens, come back and retry.
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            {INTERNAL_SIGN_IN_URL ? (
              <button type="button" className="btn-primary text-sm" onClick={openInternalSignIn}>
                Sign in to the internal API
              </button>
            ) : null}
            <button type="button" className="btn-secondary text-sm" onClick={onRetry}>
              Retry
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
